<template>
  <div class="ufi-card primaryFont">
    <div class="card-header">
      <div class="refresh-icon flex justify-content-center">
        <RotateCcw
          color="#09447C"
          :size="16"
          @click="$emit('reload')"
          :class="{ 'is-disabled': loading }"
        />
      </div>
      <h3 class="title" :style="{ fontSize: titleSize }">{{ title }}</h3>
    </div>
    <apexchart
      v-if="!loading"
      type="radialBar"
      height="300"
      :options="chartOptions"
      :series="series"
    />
    <div
      v-else
      class="w-full flex justify-content-center align-items-center"
      style="height: 50% !important"
    >
      <ProgressSpinner style="width: 60px; height: 60px" strokeWidth="2" />
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { RotateCcw } from "lucide-vue";

const props = defineProps({
  title: { type: String, required: true },
  series: { type: Array, required: true },
  labels: { type: Array, required: true },
  titleSize: {
    type: String,
    default: "32px",
  },
  loading: {
    type: Boolean,
    default: false,
  },
});

const chartOptions = ref({
  chart: {
    type: "radialBar",
    height: 350,
  },
  plotOptions: {
    radialBar: {
      hollow: {
        size: "70%",
        background: "transparent",
      },
      track: {
        background: "#f0f0f0",
        strokeWidth: "100%",
        margin: 5,
      },
      dataLabels: {
        name: {
          show: true,
          fontSize: "18px",
          fontWeigth: 500,
          fontFamily: "IBM Plex Sans",
          color: "#0B5195",
        },
        value: {
          show: true,
          fontSize: "18px",
          fontWeigth: 500,
          fontFamily: "IBM Plex Sans",
          color: "#0B5195",
          formatter: function (val) {
            return val.toString();
          },
        },
      },
    },
  },
  responsive: [
    {
      breakpoint: 480,
      options: {
        legend: {
          show: false,
        },
      },
    },
  ],
  labels: props.labels,
  colors: ["#3AC0EB"],
  legend: {
    show: false,
  },
});
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:wght@400;600&display=swap");

.ufi-card {
  max-width: 165px;
  min-height: 250px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 4px 12px #00000040;
  text-align: center;
}

.title {
  color: #09447c;
  font-weight: 700;
  margin: 0;
  margin-top: 20px;
  min-height: 47px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.card-header {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
}

.refresh-icon {
  position: absolute;
  right: 16px;
  top: 10px;
  cursor: pointer;
  color: #0b5195;
  font-size: 1.2rem;
  transition: transform 0.2s ease;
}

.refresh-icon:hover {
  transform: rotate(-90deg);
}

:deep(.p-progress-spinner-circle) {
  stroke: #3ac0eb !important;
}

:deep(.is-disabled) {
  opacity: 0.4;
  pointer-events: none;
  cursor: default;
}
</style>
